import type {
  Region,
  RegionParams,
} from "wavesurfer.js/dist/plugins/regions.js"

export type AudioRegionParams = RegionParams

export function formatAudioMarkerTime(timeSeconds: number): string {
  const minutes = Math.floor(timeSeconds / 60)
  const seconds = Math.floor(timeSeconds % 60)
  return `${minutes}:${seconds.toString().padStart(2, "0")}`
}

export function parseAudioMarkerTime(input: string): number | null {
  const match = input.match(/^(\d+):(\d{2})$/)
  if (!match) {
    return null
  }
  return Number.parseInt(match[1], 10) * 60 + Number.parseInt(match[2], 10)
}

export function resolveAudioMarkerTime({
  currentTime,
  duration,
  hoverTime,
  manualTime,
}: {
  currentTime: number
  duration: number
  hoverTime: number | null
  manualTime: string
}): number {
  const typedTime = manualTime.trim()
  const parsedManualTime = typedTime ? parseAudioMarkerTime(typedTime) : null
  const markerTime = typedTime
    ? (parsedManualTime ?? hoverTime ?? currentTime)
    : (hoverTime ?? currentTime)
  return Math.max(0, Math.min(markerTime, duration))
}

export function serializeAudioRegions(regions: Region[]): AudioRegionParams[] {
  return regions.map((region) => ({
    id: region.id,
    start: region.start,
    end: region.end ?? region.start + 1,
    color: region.color,
    drag: region.drag,
    resize: region.resize,
    resizeStart: region.resizeStart,
    resizeEnd: region.resizeEnd,
  }))
}

export function toAudioMarkerParams(region: AudioRegionParams): RegionParams {
  return {
    id: region.id,
    start: region.start,
    end: region.start,
    color: region.color ?? "rgba(147, 51, 234, 0.5)",
    drag: true,
    resize: false,
  }
}

export function toEditableAudioRegionParams(
  region: AudioRegionParams,
): RegionParams {
  return {
    id: region.id,
    start: region.start,
    end: region.end ?? region.start + 1,
    color: region.color ?? "rgba(147, 51, 234, 0.5)",
    content: region.content,
    drag: true,
    resize: true,
  }
}
